import React from "react";

import styles from "./styles.module.scss";

const InputNote = ({ note }) => <p className={styles.note}>{note}</p>;

export default InputNote;
